import APIConstant from "./APIConstant";

/**
 * Resolve the numeric client id of the client currently selected in the header.
 *
 * state.client.activeClient holds the mongo _id of the selection (see
 * Header.js -> getClientCoursesRequest). The row itself can come from either
 * the logged in user's own clients or the full client list, and depending on
 * the source the numeric id sits on `clientid` or on `id` - Header.js reads
 * `clientid || id` for the same reason.
 *
 * @returns {number|null} numeric client id, or null when it cannot be resolved
 */
export const getActiveClientId = (userState, clientState) => {
  const activeId = clientState?.activeClient;
  if (!activeId) return null;

  const match =
    userState?.loggedInUser?.clients?.find((c) => c?._id === activeId) ||
    clientState?.allClientList?.find((c) => c?._id === activeId);

  const raw = match?.clientid ?? match?.id;
  const num = Number(raw);
  return Number.isFinite(num) ? num : null;
};

/** SDX sync is offered for one client only */
export const isSdxClient = (userState, clientState) =>
  getActiveClientId(userState, clientState) === APIConstant.SDX_CLIENT_ID;
